import './module/xps-product-finder';
import './init/api-service.init';
import './module/sw-cms/elements/product-finder';
import './module/sw-cms/blocks/commerce/product-finder';


const { Application } = Shopware;

Application.addServiceProviderDecorator('cmsService', (cmsService) => {
    cmsService.registerCmsElement({
        name: 'product-finder',
        label: 'sw-cms.elements.productFinder.label',
        component: 'sw-cms-el-product-finder',
        configComponent: 'sw-cms-el-config-product-finder',
        previewComponent: 'sw-cms-el-preview-product-finder',
        defaultConfig: {
            productFinder: {
                source: 'static',
                value: null,
                required: true,
                entity: {
                    name: 'xps_product_finder'
                }
            }
        }
    });

    return cmsService;
});